import { render, staticRenderFns } from "./MastercardSvg.vue?vue&type=template&id=4ec951bb&scoped=true&"
import script from "./MastercardSvg.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MastercardSvg.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec951bb",
  null
  
)

export default component.exports